export const Footer = () => {
  const product = [
    {
      title: "全球SD-WAN网络加速服务",
      url: "/sdwan",
    },
    {
      title: "企业组网/私有化部署",
      url: "/private",
    },
    {
      title: "全球直播专线/TK直播养号",
      url: "/tiktok",
    },
    {
      title: "全球办公网络与应用加速",
      url: "/saas",
    },
    // {
    //   title: "光年游戏加速器",
    // },
  ];

  const help = [
    {
      title: "联系客服",
    },
    {
      title: "我要建议",
    },
    {
      title: "控制台",
    },
    {
      title: "常见问题",
    },
  ];
  const about = [
    {
      title: "关于我们",
      url: "/about",
    },
    {
      title: "加入我们",
    },
    {
      title: "商务合作",
      url: "https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b",
    },
  ];

  const friendLinks = [
    {
      id: 1,
      name: "卖家111跨境电商导航",
      url: "https://www.maijia111.com/",
    },

    {
      id: 2,
      name: "91push",
      url: "https://www.91push.com/",
    },

    {
      id: 3,
      name: "电狐加速器",
      url: "http://www.dianhv.com/",
    },
    {
      id: 4,
      name: "小狐狸游戏网",
      url: "https://news.xiaohuli.net/",
    },
  ];
  return (
    <div className="w-full pb-[1.25rem] pt-[4.25rem] pl-[13rem] pr-[15rem]">
      <div className="flex  gap-[50px]">
        <div className="flex-1 flex flex-col  mr-[20px]">
          <img src="/imgs/logo-footer.png" className="w-[190px] h-[43px]" />
          <div className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[1.125rem] font-light leading-6 mt-[1.25rem] max-w-[75%]">
            光年无界出海网络服务，为出海企业提供了一个可快速落地的全球跨境网络一站式服务。自研的软硬件系统、覆盖全球的网络资源、专业的运维团队，依托三大运营商的网络专线资源，天翼云、火山云、腾讯云等主流云平台深度合作赋能，为全球跨境短视频直播、全球跨境电商企业、商家、MCN机构、游戏出海平台等提供稳定、高速、安全的跨境网络服务。
          </div>
        </div>
        <div
          style={{
            transform: "scale(calc(1 / max(1, var(--page-scale, 1))))",
            transformOrigin: "top center",
            willChange: "transform",
          }}
        >
          <InfoCol title="产品与服务" list={product} />
        </div>
        <div
          style={{
            transform: "scale(calc(1 / max(1, var(--page-scale, 1))))",
            transformOrigin: "top center",
            willChange: "transform",
          }}
        >
          <InfoCol title="帮助与支持" list={help} />
        </div>
        <div
          style={{
            transform: "scale(calc(1 / max(1, var(--page-scale, 1))))",
            transformOrigin: "top center",
            willChange: "transform",
          }}
        >
          <InfoCol title="关于我们" list={about} />
        </div>
      </div>
      <div className="mt-[16px] rounded-[16px] bg-[rgba(255,255,255,0.6)] ">
        <div className="text-[19px] font-bold text-[#333333]">友情链接</div>
        <div className="mt-[10px] flex flex-wrap gap-[10px]">
          {friendLinks.map((val) => {
            return (
              <a
                key={val.id}
                href={val.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div key={val.id} className="flex items-center gap-[5px]">
                  <div className="h-[2px] w-[2px] rounded-full bg-[#333333]" />
                  <div className="text-[15px] font-normal text-[#333333]">
                    {val.name}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
      <div className="w-full h-[0.0625rem] bg-[rgba(51,51,51,0.20)] my-[2rem]"></div>
      <div className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[1.125rem] font-light leading-none flex items-center ">
        杭州光年无界科技有限公司&nbsp;|&nbsp;
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="flex items-center justify-center">
            <img
              src="/imgs/gh.png"
              alt="豫公网安备"
              className="mr-[5px] h-[12px] w-[12px]"
            />
            浙ICP备2025193092号-2
          </div>
        </a>
        &nbsp;|&nbsp;增值电信业务经营许可 B1-20253714
      </div>
    </div>
  );
};

const InfoCol = (props: {
  list: { title: string; url?: string }[];
  title: string;
}) => {
  const { title, list } = props;
  return (
    <div className="flex flex-col">
      <div className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[1.375rem] font-bold leading-none">
        {title}
      </div>
      <div className="flex flex-col gap-[1rem] mt-[1rem]">
        {list.map((val) => {
          return val.url ? (
            <a
              href={val.url}
              target="_blank"
              rel="noopener noreferrer"
              key={val.title}
              className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[1.125rem] font-light leading-none cursor-pointer"
            >
              {val.title}
            </a>
          ) : (
            <div
              key={val.title}
              className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[1.125rem] font-light leading-none cursor-pointer"
            >
              {val.title}
            </div>
          );
        })}
      </div>
    </div>
  );
};
